import {
  HEX_000000,
  HEX_292D38,
  HEX_646A7E,
  HEX_A4A9B3,
  HEX_ADB5C7,
  HEX_CED7E2,
  HEX_E2E8F0,
  HEX_EB3330,
} from '@tanium/colors';
import { getRgbString } from '@tanium/coreui-utils';
import { LearnToUse, LearnToUseDark } from '@tanium/react-graphics';
import {
  Background1,
  Border4,
  defineColor,
  defineThemeValue,
  Link,
} from '@tanium/react-theme-definition';
import { Theme } from '@tanium/theme-data';

export const ContainerFill = Background1;
export const ContainerBorder = Border4;
export const ContainerShadow = (theme: Theme) => {
  const color = defineColor([HEX_CED7E2, HEX_000000]);
  return `0 2px 1px ${getRgbString(color(theme), '75%')}`;
};

export const HeadingText = defineColor([HEX_292D38, HEX_E2E8F0]);
export const SummaryText = defineColor([HEX_646A7E, HEX_A4A9B3]);
export const LinkText = Link;
export const LinkIconFill = defineColor([HEX_EB3330, HEX_ADB5C7]);

export const BannerIcon = defineThemeValue([LearnToUse, LearnToUseDark]);
